module.exports = __webpack_public_path__ + "static/media/i_retiro.1d4dbe17.png";